import { Overlay } from '@angular/cdk/overlay';
import { ViewChild } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { LinkDeviceOwnerDialogComponent } from '../link-device-owner-dialog/link-device-owner-dialog.component';
import { LinkOwnerDeviceDialogComponent } from '../link-owner-device-dialog/link-owner-device-dialog.component';
import { ControlUser } from '../model/controlUser';
import { DeviceService } from '../service/device.service';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { environment } from 'src/environments/environment';
import { UserImportDialogComponent } from '../user-import-dialog/user-import-dialog.component';
import { AppComponent } from '../app.component';
import { OwnerData } from '../model/ownerData';

@Component({
  selector: 'app-owner-detail',
  templateUrl: './owner-detail.component.html',
  styleUrls: ['./owner-detail.component.css']
})
export class OwnerDetailComponent implements OnInit {

  @ViewChild('ownerloader', { static: true }) loader;


  selectedTabIndex: number;
  filterString: string;

  devicesString: string = $localize`:@@owner_detail_devices:Dispositivi`;
  automationsString: string = $localize`:@@owner_detail_automations:Automazioni`;
  usersString: string = $localize`:@@owner_detail_users:Utenti`;
  groupsString: string = $localize`:@@owner_detail_groups:Gruppi`;

  reload: Object;
  owner: ControlUser;
  showImportUsersButton: boolean = false;

  newDisplayName : string = "";

  closeToastString: string = $localize`:@@device_detail_close_toast:chiudi`;

  constructor(
    private userService: UserService,
    private deviceService: DeviceService,
    public appComponent: AppComponent,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private overlay: Overlay) {
  }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('tab')) {
      const tab = Number(this.route.snapshot.queryParamMap.get('tab'));
      this.selectedTabIndex = tab;
    } else {
      this.selectedTabIndex = 0
    }


    // this.managerUid = this.route.snapshot.paramMap.get('managerUid');
    // if (this.managerUid) {
    //   Log.debug('managerUid: ' + this.managerUid);
    // }

  }

  ngAfterViewInit() {
    this.loader.showLoading();

    this.getOwner();
    this.getMe();
  }

  getOwner(): void {

    Log.debug('paramMap: ' + JSON.stringify(this.route.snapshot.paramMap));

    const uid = this.route.snapshot.paramMap.get('uid');
    Log.debug('owner: ' + uid);

    this.userService.getUser(uid).subscribe(owner => {

      if(owner.displayName.length < 3){
        this.newDisplayName = owner.email;
      } else{
        this.newDisplayName = owner.displayName;
      }

      this.owner = owner;
    
      this.reload = new Object();

      this.loader.hideLoading();

      this.cdRef.detectChanges();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }



  getMe(): void {
    this.userService.getMe().subscribe(user => {
      if (user.email == "admin@1control.it") {
        this.showImportUsersButton = true;
      }
    });
  }

  onDeviceSelected(device): void {

    this.router.navigate(['device/' + device.serial]);
  }

  usersImport(): void {
    Log.debug("uploadUsers clicked");
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    // let existingUsersPhoneNumbers : string[] = [];

    // console.log("this.usersList");
    // console.log(this.usersList);

    // for(let i=0; i < this.usersList.length; i++){
    // existingUsersPhoneNumbers.push(this.usersList[i].phoneNumber);
    // }

    // console.log("existingUsersPhoneNumbers");
    // console.log(existingUsersPhoneNumbers);

    const dialogRef = this.dialog.open(UserImportDialogComponent, {
      width: "800px",
      data: {
        ownerUid: this.owner.uid
        // ,  existingUsersPhoneNumbers : existingUsersPhoneNumbers
      },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        // if (response == "Success") {
        //   window.location.reload();
        // }
      }
    });
  }

  isPilomatDev(): boolean {
    if (environment.onecontrol.serverFolder == "pilomatdev") {
      return true;
    } else {
      return false;
    }
  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  connectDevice(): void {

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(LinkOwnerDeviceDialogComponent, {
      width: '850px',
      data: { owner: this.owner },
      scrollStrategy
    });

    dialogRef.afterClosed().subscribe(result => {

      if (!result) {
      }
      else if (result.device) {

        this.deviceService.linkDeviceToOwner(result.device.serial, this.owner.uid).subscribe(deviceOwnerData => {

          this.loader.hideLoading();

          this.reload = new Object();


          let snackBarRef = this.snackBar.open($localize`:@@ownerdetail_device_connected:Dispositivo associato correttamente`, this.closeToastString, {
            duration: 3000
          });

          this.cdRef.detectChanges();

        }, error => {

          this.loader.hideLoading();
          this.loader.showError();
        });
      }
    });
  }
  

  saveName(){

    this.loader.showLoading();

    Log.debug("SaveName clicked");
    Log.debug(this.owner);

    let updatedOwnerData = new OwnerData();
    updatedOwnerData.ownerUid = this.owner.uid;
    updatedOwnerData.name = this.newDisplayName;
    this.owner.displayName = this.newDisplayName;
    updatedOwnerData.owner = this.owner;


    this.userService.createUpdateOwnerData(this.owner.uid, updatedOwnerData).subscribe(response => {
      Log.debug(response);

      setTimeout(() => {
        this.loader.hideLoading();
        let snackBarRef = this.snackBar.open($localize`:@@ownerdetail_update_success:Dati aggiornati con successo`, this.closeToastString, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });
      }, 250);

    });
  }


  onTabChange(event: any) {
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: { tab: event.index } });
  }

  openRequestForm(){

    // senza /language/ perchè dovrebbe gestirlo in automatico
    let url = "https://pilomat.1control.eu/pilomat/#/join/" + this.owner.uid;

    window.open(url, '_blank').focus();

  }
}
